import styled from 'styled-components';
import {JackpotBetWidgetLogoDefaultBox} from './jackpot-bet-widget-logo.default.box';

export const JackpotBetWidgetLogoCasino777Box = styled(JackpotBetWidgetLogoDefaultBox)`
    height: 10rem;
    width: 19rem;  
    padding: 5rem;

    @media ${({theme}) => theme.mediaQuery.xxsAndBelow} {
        width: 15rem;  
        padding: 4rem;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        width: 27rem;  
        padding: 7rem;
    }
`;

